export const NE_WELCOME_CREDIT_PROMOTION = 'br-welcome-credit';

export enum NE_TYPE_OF_PAYMENT_PROMOTION {
  PRE_PAID = 'PrePaid',
  POST_PAID = 'PostPaid',
}

export const NE_POST_PAID_SHIPPING_CONCEPT_CODES = new Set([
  'shipping-fee',
  'shipping-cost',
  'shipping-cost-carrier',
  'shipping-penalty',
]);

export enum NE_PRINT_LABEL_SOURCE {
  ORDERS_LIST = 'OrdersList',
  ORDER_DETAILS = 'OrderDetails',
}
